import React, { useEffect } from "react";
import { getCreditos } from "../../../../app/store/actions/creditoActions";
import { connect } from "react-redux";
import PrestamoDashboard from "./PrestamoDashboard";
import PropTypes from "prop-types";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

const mapState = (state) => ({
  creditos: state.creditoReducer.creditos,
  loading: state.creditoReducer.loadingCreditos,
  currentUser: state.auth.currentUser,
});

const actions = {
  getCreditos,
};
const PrestamoPage = ({ creditos, loading, getCreditos, currentUser }) => {
  useEffect(() => {
    if (currentUser?.username) {
      getCreditos();
    }
  }, [getCreditos, currentUser]);

  if (!currentUser) {
    return <LoadingComponent content="Cargando usuario..." />;
  }

  if (loading) return <LoadingComponent content="Cargando préstamos..." />;
  return (
    <>
      <PrestamoDashboard creditos={creditos} />
    </>
  );
};

PrestamoPage.propTypes = {
  creditos: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  getCreditos: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
};

export default connect(mapState, actions)(PrestamoPage);
